import { ReactNode } from "react";
import MuiDialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import styles from "./Dialog.module.scss";

const mergeClassNames = (...classes: Array<string | undefined>) =>
  classes.filter(Boolean).join(" ");

interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
}

export const Dialog = ({ open, onOpenChange, children }: DialogProps) => {
  return (
    <MuiDialog
      open={open}
      onClose={() => onOpenChange(false)}
      className={styles.dialog}
    >
      {children}
    </MuiDialog>
  );
};

interface DialogContentProps {
  children: ReactNode;
  className?: string;
}

export const DialogContent = ({ children, className }: DialogContentProps) => {
  return (
    <MuiDialogContent
      className={mergeClassNames(styles.dialogContent, className)}
    >
      {children}
    </MuiDialogContent>
  );
};

interface DialogHeaderProps {
  children: ReactNode;
  className?: string;
}

export const DialogHeader = ({ children, className }: DialogHeaderProps) => {
  return <div className={className}>{children}</div>;
};

interface DialogActionsProps {
  children: ReactNode;
  className?: string;
}

export const DialogActions = ({ children, className }: DialogActionsProps) => {
  return (
    <div className={mergeClassNames(styles.dialogActions, className)}>
      {children}
    </div>
  );
};

interface DialogRowProps {
  children: ReactNode;
  className?: string;
}

export const DialogRow = ({ children, className }: DialogRowProps) => {
  return (
    <div className={mergeClassNames(styles.dialogRow, className)}>
      {children}
    </div>
  );
};

interface DialogTitleProps {
  children: ReactNode;
  className?: string;
}

export const DialogTitle = ({ children, className }: DialogTitleProps) => {
  return (
    <MuiDialogTitle className={mergeClassNames(styles.dialogTitle, className)}>
      {children}
    </MuiDialogTitle>
  );
};

interface DialogDescriptionProps {
  children: ReactNode;
  className?: string;
}

export const DialogDescription = ({
  children,
  className,
}: DialogDescriptionProps) => {
  return <p className={className}>{children}</p>;
};
